// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","385":"0819c3c220ad7c837d4dbc2581170ff139e999b8","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"21110daf983561717480","385":"491617fee08401273fc6","453":"05eb3c9ca9143ce6f32d"}[chunkId] + ".js";
};